import axios from "axios";
import applyConverters from "axios-case-converter";
import config from "@/config";
import { request } from "./interceptors";

const instance = applyConverters(axios.create(config.axios));

instance.interceptors.request.use(request);

export default instance;
